import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API, Storage } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class UpdateProfile extends Component {

validateForm(){
  return true;
}

constructor(props){
  super(props);

  this.state = {
      isPersonalDetailsLoading: false,
      successMsg: "",
      errorMsg: "",
      phonenumber: this.getPropertyValue("phonenumber"),
      dob: this.getPropertyValue("dob"),
      gender: this.getPropertyValue("gender"),
      profilePic: this.getPropertyValue("profilePicUrl"),
      shareDetails: this.getPropertyValue("shareDetails"),
      shareDetailsUI: this.getCheckedState(this.getPropertyValue("shareDetails"))

  };

}

getCheckedState(propValue){
  if(propValue === "true"){
    return true;
  }
  return false;
}

getPropertyValue(propertyName){
  if(this.props.userProfile[propertyName] && this.props.userProfile[propertyName].length > 0){
    return this.props.userProfile[propertyName];
  }
  return "";
}

handleChange = event => {
  event.preventDefault();
  this.setState({
    [event.target.id]: event.target.value
  });
}

handleCheckboxChange = event => {
  this.setState({

    [event.target.id+"UI"]: !this.state[event.target.id+"UI"],
    [event.target.id]: !this.state[event.target.id+"UI"]+""

  });
}

handleFileChange = async event => {
  this.file = event.target.files[0];
  this.setState({profilePic: window.URL.createObjectURL(this.file)});
}

submitPersonalDetails = async event => {
    event.preventDefault();
    this.setState({ isPersonalDetailsLoading: true});
    var personalDetails = {};

    try{
      personalDetails.shareDetails = this.state.shareDetails;
      var isAnythingChanged = false;
      const attachments = [];
      if(this.file && this.file.size > config.MAX_ATTACHMENT_SIZE){
        alert("Please pick a profile pic smaller than 5MB");
        return;
      }

      if(this.file){
        isAnythingChanged = true;
        personalDetails.profilePic = await s3Upload(this.file);
      }
      if(this.state.dob && this.state.dob.length > 0){
        isAnythingChanged = true;
        personalDetails.dob = this.state.dob;
      }
      if(this.state.gender && this.state.gender.length > 0){
        isAnythingChanged = true;
        personalDetails.gender = this.state.gender;
      }

      if(this.state.phonenumber && this.state.phonenumber.length > 0){
        isAnythingChanged = true;
        personalDetails.phonenumber = this.state.phonenumber;
      }

      if(isAnythingChanged) {
          await this.props.updateUserProfile(personalDetails);
          this.setState({successMsg: "Successfully updated your profile."});
      }
      this.setState({isPersonalDetailsLoading: false});


    }catch(e){
            this.setState({isPersonalDetailsLoading: false, errorMsg: e.message});
    }
 }

 getSuccessNotification(successMsg){
    return this.state.successMsg && this.state.successMsg.length > 0
                            ? <div className="alert alert-success" role="alert">
                                {this.state.successMsg}
                              </div>
                            : "";
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

render() {
    return(
      <div className="container">
            <br />
            <div className="row cols-xs-space cols-sm-space cols-md-space">
                  <div className="col-lg-12">
                    <div className="row">
                       <div className="col-lg-2"></div>

                       <div className="col-lg-8 profile-udpate-widget">
                          <div className="card">
                              <div className="card-title b-xs-bottom">
                                  <h3 className="heading heading-sm text-uppercase">Personal Details</h3>

                              </div>
                              <div className="card-body">
                                  <div className="row">
                                      <div className="col-sm-12">
                                          <form id="personal-details-form"
                                              onSubmit={this.submitPersonalDetails}>
                                              <div className="form-group">
                                                  <label htmlFor="phonenumber">Contact Number</label>
                                                  <input type="number" id="phonenumber"
                                                       className="form-control"
                                                       placeholder=""
                                                       value={this.state.phonenumber}
                                                       onChange={this.handleChange} />
                                              </div>
                                              <div className="form-group">
                                                  <label htmlFor="dob">Date Of Birth</label>
                                                  <input type="date" id="dob"
                                                       className="form-control"
                                                       id="dob" placeholder=""
                                                       value={this.state.dob}
                                                       onChange={this.handleChange} />
                                              </div>
                                              <div className="form-group">
                                                  <label htmlFor="gender">Select Gender</label>
                                                  <select className="form-control"
                                                          id="gender"
                                                          value={this.state.gender}
                                                          onChange={this.handleChange}>
                                                      <option value="Female">Female</option>
                                                      <option value="Male">Male</option>
                                                      <option value="Ignore">Ignore</option>
                                                  </select>
                                              </div>
                                              <div className="form-group">
                                                  <div className="checkbox">
                                                     <input type="checkbox"
                                                            name="shareDetails"
                                                            onChange={this.handleCheckboxChange}
                                                            checked={this.state.shareDetailsUI}
                                                            id="shareDetails"
                                                            className="left-padding"/>
                                                       <label >
                                                            Share my profile details with other doctors
                                                      </label>
                                                  </div>
                                              </div>
                                              <div className="form-group">
                                                  <label htmlFor="profilePic">Profile Picture &nbsp;</label>
                                                  <input type="file" name="profilePic"
                                                          id="profilePic"
                                                          onChange={this.handleFileChange} />
                                              </div>

                                              <div className="form-group">
                                                  <label >Profile Picture Preview &nbsp;</label>
                                                  {
                                                    this.state.profilePic ?
                                                          <img src={this.state.profilePic} className="img-center profile-pic" />
                                                          : <span></span>
                                                  }

                                                  <span className="text-info">If your picture is not straight.
                                                       <br />
                                                       Please use some image editing softwares to change your picture orientation before uploading.
                                                       <br />
                                                       If the orientation is right on your laptop, just open the picture and save it. This might fix the orientation.

                                                  </span>
                                              </div>


                                              <br />
                                              <div className="form-group align-center">

                                                  <LoaderButton block="true"
                                                        disabled={!this.validateForm()} type="submit"
                                                        isLoading={this.state.isPersonalDetailsLoading} text=" Update "
                                                        loadingText="Updating Details..."
                                                        className="btn btn-primary"/>
                                              </div>

                                          </form>
                                          {this.getErrorElement()}
                                          {this.getSuccessNotification()}
                                      </div>
                                  </div>
                              </div>
                          </div>
                       </div>

                       <div className="col-lg-2"></div>
                    </div>
                  </div>
            </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/UpdateProfile.js